import('./environment').catch((err) => {
  // eslint-disable-next-line no-console
  console.error(err);
});
